import * as React from 'react';

import { ErrorProps } from './types';
import muiStyles from '../fieldStyles';

export default function SimpleErrorMessage(props: ErrorProps) {
    const {
        className,
        error
    } = props;

    const classes = muiStyles(props);

    return (
        error ? (
            <div className={`${className} ${classes.fieldError}`}>{error}</div>
        )
            : null
    );
}